// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DHZV","content":"styles_content__3m7gS"};